import { __exports as cultureFormatter } from './_virtual-cultureFormatter.js';

var hasRequiredCultureFormatter;

function requireCultureFormatter () {
	if (hasRequiredCultureFormatter) return cultureFormatter;
	hasRequiredCultureFormatter = 1;

	Object.defineProperty(cultureFormatter, "__esModule", {
	  value: true
	});
	cultureFormatter.CultureFormatter = void 0;
	class CultureFormatter {
	  format(culture) {
	    try {
	      const firstPart = culture.split('-')[0];
	      const secondPart = culture.split('-')[1];
	      return [firstPart.toLowerCase(), secondPart.toUpperCase()].join('-');
	    } catch (e) {
	      throw new Error("Unable to format culture, not in the right format ".concat(culture, ". ").concat(e));
	    }
	  }
	}
	cultureFormatter.CultureFormatter = CultureFormatter;
	
	return cultureFormatter;
}

export { requireCultureFormatter as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-cultureFormatter.js.map
